import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=3ac8fc84&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports